import React from 'react'
import { CartPreviewData } from 'types/progressiveDiscountTypes'
import { NextHint } from 'hooks/useCartProgressiveDiscount'
import { formatBRL } from 'utils/progressiveDiscount'
import * as Style from './styles'

interface Props {
  preview: CartPreviewData | null
  loading: boolean
  error: boolean
  hasEditedPrices: boolean
  hint?: NextHint | null
  side?: 'label' | 'value' | 'notice' | 'hint'
}

export const CartProgressiveLine = ({ preview, loading, error, hasEditedPrices, hint, side }: Props) => {
  if (side === 'notice') {
    if (!hasEditedPrices) return null
    return (
      <Style.EditedPricesNotice>
        Desconto progressivo nao se aplica a pedidos com valores alterados manualmente
      </Style.EditedPricesNotice>
    )
  }

  if (side === 'hint') {
    if (hasEditedPrices || error || !preview || !hint) return null

    const floor = hint.isAmountTrigger ? hint.missingLabel : `${hint.missing} ${hint.missing === 1 ? 'unidade' : 'unidades'}`

    if (hint.itemLabel) {
      return (
        <Style.NextTierHintText>
          Faltam {floor} para {hint.itemLabel}
          {hint.freightLabel ? ` + ${hint.freightLabel}` : ''}
        </Style.NextTierHintText>
      )
    }

    if (hint.pureValueLabel) {
      return (
        <Style.NextTierHintText>
          Faltam {floor} para {hint.pureValueLabel}
        </Style.NextTierHintText>
      )
    }

    return (
      <Style.NextTierHintText>
        Faltam {floor} para {hint.nextPercent}% de desconto
      </Style.NextTierHintText>
    )
  }

  if (hasEditedPrices || error || !preview || preview.total_progressive_discount === 0) {
    return null
  }

  if (side === 'label') {
    return <Style.ProgressiveLabel>Desconto progressivo</Style.ProgressiveLabel>
  }

  const valueText = loading ? '...' : `- ${formatBRL(preview.total_progressive_discount)}`

  return <Style.ProgressiveValue>{valueText}</Style.ProgressiveValue>
}
